if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    show(opener) {
      this.setupNavigation();
      super.show(opener);
      const id = opener.getAttribute('data-media-id');
      this.activeIndex = Math.max(0, this.mediaItems.findIndex((element) => element.getAttribute('data-media-id') === id));
      this.showActiveMedia();
    }

    setupNavigation() {
      this.classList.add('fnr-scroll-gallery');
      this.mediaContainer = this.querySelector('[role="document"]');
      this.mediaItems = Array.from(this.mediaContainer.children).filter((element) => element.hasAttribute('data-media-id'));
      if (this.navigationReady) return;
      this.navigationReady = true;
      const dialog = this.querySelector('[role="dialog"]');
      // Dawn closes media modals on mouse release; controls and scrollbar must remain usable.
      dialog.addEventListener('pointerup', (event) => event.stopPropagation());
      const arrow = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>';
      this.previousButton = document.createElement('button');
      this.previousButton.type = 'button';
      this.previousButton.className = 'fnr-gallery-arrow fnr-gallery-arrow--prev';
      this.previousButton.setAttribute('aria-label', 'Previous enlarged image');
      this.previousButton.innerHTML = arrow;
      this.nextButton = document.createElement('button');
      this.nextButton.type = 'button';
      this.nextButton.className = 'fnr-gallery-arrow fnr-gallery-arrow--next';
      this.nextButton.setAttribute('aria-label', 'Next enlarged image');
      this.nextButton.innerHTML = arrow.replace('M15 5l-7 7 7 7','M9 5l7 7-7 7');
      this.positionLabel = document.createElement('p');
      this.positionLabel.className = 'fnr-gallery-position';
      this.positionLabel.innerHTML = '<span role="status" aria-live="polite" aria-atomic="true"></span><small>Scroll for more photos</small>';
      dialog.append(this.previousButton, this.nextButton, this.positionLabel);
      this.previousButton.addEventListener('click', () => this.step(-1));
      this.nextButton.addEventListener('click', () => this.step(1));
      this.addEventListener('keydown', (event) => {
        if (event.target.closest('input, textarea, select, video, model-viewer, iframe')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.mediaContainer.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          if (!this.hasAttribute('open')) return;
          const anchor = this.mediaContainer.getBoundingClientRect().top + 100;
          let index = 0;
          this.mediaItems.forEach((element, i) => { if (element.getBoundingClientRect().top <= anchor) index = i; });
          this.activeIndex = index;
          this.updatePosition();
        });
      }, {passive:true});
    }

    step(direction) {
      if (!this.mediaItems.length) return;
      this.activeIndex = (this.activeIndex + direction + this.mediaItems.length) % this.mediaItems.length;
      this.showActiveMedia();
    }

    updatePosition() {
      this.positionLabel.querySelector('[role="status"]').textContent = `${this.activeIndex + 1} / ${this.mediaItems.length}`;
      this.previousButton.disabled = this.nextButton.disabled = this.mediaItems.length < 2;
    }

    showActiveMedia() {
      const media = this.mediaItems[this.activeIndex];
      if (!media) return;
      if (typeof pauseAllMedia === 'function') pauseAllMedia();
      this.mediaItems.forEach((element) => element.classList.toggle('active', element === media));
      this.mediaContainer.scrollTop += media.getBoundingClientRect().top - this.mediaContainer.getBoundingClientRect().top - 75;
      this.updatePosition();
      const template = media.querySelector('template');
      if (media.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) media.loadContent();
    }
  });
}
